module.exports = __webpack_public_path__ + "static/media/webhook-system.e378a182.png";